import { FormRating, FormRatingProps } from '@makyoapp/makyo-tw-ui'

export type CompFieldRatingProps = FormRatingProps

/**
 * CompFieldRatingCore
 */
export const CompFieldRatingCore = (props: CompFieldRatingProps) => {
  return <FormRating {...props} />
}
